import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { NewsAndGuidesShareLinksQuery, NewsAndGuidesShareLinksQueryVariables } from './api.graphql';
import { NewsAndGuidesShareLinks } from './api.graphql';

export type NewsAndGuidesShareLinksResult = NonNullable<NewsAndGuidesShareLinksQuery['details']>['shareLinks'];

export async function getNewsAndGuidesShareLinks(
	{ countryCode, locale, slugOrId }: { countryCode: string; locale: string; slugOrId: string },
	{ gql }: UtilityContext,
): Promise<NewsAndGuidesShareLinksResult | null> {
	try {
		const { data } = await gql.fetch<NewsAndGuidesShareLinksQuery, NewsAndGuidesShareLinksQueryVariables>({
			query: NewsAndGuidesShareLinks,
			variables: { countryCode, locale, slugOrId },
			rejectOnError: true,
		});

		if (!data.details) return null;

		return data.details.shareLinks;
	} catch {
		return null;
	}
}
